import { FC } from "react";
import { Box } from "@chakra-ui/react";
import { useScrollToAnchor } from "~/hooks/useScrollToAnchor";

interface Props {
  children: React.ReactNode;
  id: string;
}

export const Anchor: FC<Props> = ({ children, id }) => {
  const { ref } = useScrollToAnchor(id);

  return (
    <Box as="span" id={id} ref={ref} w="100%">
      {children}
    </Box>
  );
};
